/* eslint-disable */

export const googleKeys = () => {
    return {
        clientId: _keys.google
    }
};
export const facebookKeys = () => {
    return {
        appId: _keys.facebook,
        fields: "name,email"
    }
};
export const stripeKeys = () => {
    return {
        stripeKey: _keys.stripe
    }
}

export const appInsightsKey = () => {
    return _keys.appInsightsKey;
    
}


// WEBPACK FOOTER //
// ./src/helpers/keys.js